import React, { memo } from "react";
import { ActionHistoryProps, DocumentsObjectType } from "../types";
import { COLORS } from "../constants";
import Download from "../../../assets/images/arrow-circle-up.svg";

interface DownloadConsentProps extends ActionHistoryProps {
  view: () => void;
  download: () => void;
  viewDocumentInfo: DocumentsObjectType;
}

const DownloadConsent: React.FC<DownloadConsentProps> = ({
  close,
  view,
  download,
  viewDocumentInfo
}) => {
  const certificate =  viewDocumentInfo.docType === 'gosiDoc' ? 'Gosi certificate' :( viewDocumentInfo.docType === 'bankDoc' ? 'Bank statement' : 'Salary statement');
  const title =  viewDocumentInfo.docType === 'gosiDoc' ? 'Gosi Certificate' :( viewDocumentInfo.docType === 'bankDoc' ? 'Bank Statement' : 'Salary Statement');

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
      style={{ background: "rgba(0,0,0,0.4)", zIndex: 9999 }}
    >
      <div
        className="bg-white p-3 rounded shadow"
        style={{
          width: "60%",
          maxWidth: "600px",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        {/* HEADER */}
        <div
          className="d-flex flex-row align-items-center justify-content-between"
          style={{ background: "#FFFFFF" }}
        >
          <h5
            className="mb-0"
            style={{
              color: COLORS.TEXT_PRIMARY,
              fontWeight: 700,
              fontSize: "24px",
            }}
          >
            {`${title} Pdf`}
          </h5>

          <button className="btn d-flex p-2 text-dark" onClick={close}>
            <i
              className="bi bi-x-lg text-dark"
              style={{ color: COLORS.TEXT_PRIMARY }}
            ></i>
          </button>
        </div>

        <div className="d-flex flex-column align-items-center justify-content-center p-0 gap-2">
          <img
            className="mt-4 mb-2"
            alt=""
            style={{
              width: 80,
              height: 80,
            }}
            src={Download}
          />
          <span className="mb-5">
            {`Do you want  download the ${certificate} PDF ?`}
          </span>
          <div className="d-flex align-items-center justify-content-center p-0 gap-4">
            <button
              type="button"
              className="btn d-flex align-items-center px-4 py-1 justify-content-center"
              style={{
                borderWidth: 1,
                borderColor: COLORS.ELECTRIC_NAVY,
                borderStyle: "solid",
                color: COLORS.ELECTRIC_NAVY,
                fontWeight: 700,
                fontSize: "15px",
                width: 100,
                height: 40,
              }}
              onClick={view}
            >
              <span>{"View"}</span>
            </button>
            <button
              type="button"
              className="btn d-flex align-items-center px-4 py-1 justify-content-center"
              style={{
                backgroundColor: COLORS.ELECTRIC_NAVY,
                color: "white",
                fontWeight: 700,
                fontSize: "15px",
                borderWidth: 1,
                borderColor: COLORS.ELECTRIC_NAVY,
                borderStyle: "solid",
                width: 100,
                height: 40,
              }}
              onClick={download}
            >
              <span>{"Download"}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(DownloadConsent);
